// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-black{background-color:#000}.ga-pink{color:#ff56b1}.text-black{color:#000}.portfolio-page .cta-section{background-image:url(/img/portfolio/pier/the-way-radio.jpg);background-position:50%;background-size:cover;height:100%;width:100%}.portfolio-page .pier-background{background:url(/img/portfolio/pier/pier-color-theme.jpg) no-repeat 50%;background-size:cover}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
